import psale1 from "../assets/nike-air-red.png";
import psale2 from "../assets/nike-adapt-bb.png";
import psale3 from "../assets/nike-adapt-bb-smart.png";

import product1 from "../assets/product1.png";
import product2 from "../assets/product2.png";
import product3 from "../assets/product3.png";
import product4 from "../assets/product4.png";
import product5 from "../assets/product5.png";
import product6 from "../assets/product6.png";
import product7 from "../assets/product7.png";
import product8 from "../assets/product8.png";
import product9 from "../assets/product9.png";
import product10 from "../assets/product10.png";
import product11 from "../assets/product11.png";
import product12 from "../assets/product12.png";

import hightlightimg from "../assets/hightlightimg.png";
import sneakershoe from "../assets/sneaker.png";




const popularsales = {
    title: "Popular Sales",
    items: [
      {
        id: "1",
        title: "Nike Addapt BB 2.0",
        text: "MEN Running Shoes",
        rating: "4.9",
        btn: "Buy Now",
        img: psale2,
        price: "20000",
        color: "from-blue-600 to-blue-500",
        shadow: "shadow-lg shadow-blue-500",
      },
      {
        id: "2",
        title: "Nike Martine Rose",
        text: "MEN Running Shoes",
        rating: "4.5",
        btn: "Buy Now",
        img: psale1,
        price: "25000",
        color: "from-red-500 to-rose-500",
        shadow: "shadow-lg shadow-rose-500",
      },
      {
        id: "3",
        title: "Nike Smart Shoe 2.0",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: psale3,
        price: "20000",
        color: "from-violet-500 to-indigo-500",
        shadow: "shadow-lg shadow-violet-500",
      },
    ],
  };
  
  const highlight = {
    heading: "HIGHLIGHTS",
    title: "NIKE AIR WITH LIMITLESS CHOICES",
    text: "Our Purpose is to move the world forward. We take action by building community, protecting our planet and increasing access to sport.",
    btn: "Explore More",
    url: "https://www.nike.com/launch/t/nocta-hot-step-black-gold",
    img: hightlightimg,
  };
  
  const sneaker = {
    heading: "FEATURED",
    title: "NIKE SNEAKERS AIR LANCING SHOES",
    text: "The radiance lives on Nike Sneakers Air Lancing Shoes, the basket ball OG that puts a fresh spin on what you know best: durably stitched overlays, clean finishes and the perfect amount of flash to make you shine.",
    btn: "Explore More",
    url: "https://sneakernews.com/2022/03/21/nike-lebron-2-retro-white-midnight-navy-varsity-crimson-dr0826-100/",
    img: sneakershoe,
  };
  
  const toprateslaes = {
    title: "Top Rated",
    items: [
      {
        id: "1",
        title: "Nike Air Low Premium",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product7,
        price: "15000",
        color: "from-sky-600 to-indigo-600",
        shadow: "shadow-lg shadow-blue-500",
      },
      {
        id: "2",
        title: "Nike Air Force Green",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product2,
        price: "15000",
        color: "from-green-500 to-emerald-500",
        shadow: "shadow-lg shadow-green-500",
      },
      {
        id: "3",
        title: "Nike Addapt BB Rose",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product3,
        price: "15000",
        color: "from-red-500 to-rose-500",
        shadow: "shadow-lg shadow-rose-500",
      },
      {
        id: "4",
        title: "Nike Air Premium",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product4,
        price: "15000",
        color: "from-orange-500 to-amber-500",
        shadow: "shadow-lg shadow-orange-500",
      },
      {
        id: "5",
        title: "Nike Adapt BB Pro",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product5,
        price: "15000",
        color: "from-gray-900 to-yellow-500",
        shadow: "shadow-lg shadow-yellow-500",
      },
      {
        id: "6",
        title: "Air Jordan PR3",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product6,
        price: "15000",
        color: "from-blue-500 to-cyan-500",
        shadow: "shadow-lg shadow-cyan-500",
      },
      {
        id: "7",
        title: "Nike Multi Smart Shoe",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product1,
        price: "15000",
        color: "from-yellow-500 to-yellow-500",
        shadow: "shadow-lg shadow-yellow-500",
      },
      {
        id: "10",
        title: "Nike Jordan Air Max",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product9,
        price: "15000",
        color: "from-[#936550] to-orange-900",
        shadow: "shadow-lg shadow-orange-800",
      },
      {
        id: "8",
        title: "Nike Old Max-x",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product10,
        price: "15000",
        color: "from-indigo-700 to-indigo-700",
        shadow: "shadow-lg shadow-indigo-500",
      },
      {
        id: "9",
        title: "Nike Lime Jordan 11",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product12,
        price: "15000",
        color: "from-green-600 to-lime-500",
        shadow: "shadow-lg shadow-lime-500",
      },
      {
        id: "12",
        title: "Nike Air Black Max",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product11,
        price: "15000",
        color: "from-slate-900 to-black",
        shadow: "shadow-lg shadow-black",
      },
      {
        id: "11",
        title: "Nike Zoom Max",
        text: "MEN Running Shoes",
        rating: "5+",
        btn: "Buy Now",
        img: product8,
        price: "15000",
        color: "from-blue-900 to-blue-500",
        shadow: "shadow-lg shadow-blue-500",
      },
    ],
  };
  
  
  
  
  
  export {sneaker, highlight, toprateslaes, popularsales };